require('../modules/es.parse-float');
var path = require('../internals/path');

module.exports = path.parseFloat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/parse-float.js
// module id = 4839
// module chunks = 25